import Grid from "@mui/material/Grid";
import { useQueryClient } from "@tanstack/react-query";
import { useAccountById } from "queries/accounts";
import { useAgencyByPlanId } from "queries/agency";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import PageLayout from "examples/LayoutContainers/PageLayout";
import Loader from "examples/Loader";

import { useNavigate } from "react-router-dom";
import SoftUITabs from "./SoftUITabs/SoftUITabs"
import AccounTab from "./components/Tabs/AccountTab"
import ContactTab from "./components/Tabs/ContactTab";
import UserTab from "./components/Tabs/UserTab";
import SaasTab from "./components/Tabs/SaasTab"
import RebillingTab from "./components/Tabs/RebillingTab";
import PromptLabels from "./components/Tabs/PromptLabels";
import Apps from "./components/Tabs/Apps";
import PrivateApps from "./components/Tabs/PrivateApps";
import AgentConfiguration from "./components/Tabs/agentconfiguration";
import AccountPlan from "./components/Tabs/AccountPlan";
import BespokeIntegrations from "./components/Tabs/BespokeIntegrations";
import BespokeUrlPage from "./components/Tabs/BespokeUrlPage";

function AccountDetail() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  // Same derivation the old onLoad() used (last URL segment), just read at
  // render time instead of inside the async handler.
  const lastPart = window.location.href.split("/").pop();

  const { data: accountData, isLoading: isAccountLoading } = useAccountById(lastPart);

  const formData = accountData?.data || {};
  const users = accountData?.users || {};
  const agencySaas = accountData?.agency_saas;
  const privateApps = accountData?.privateApps?.[0]?.apps;

  // Mirrors the old agenecySaas() call: fired unconditionally once the
  // account record has loaded, keyed off its plan_id.
  const { data: saasdatda = {} } = useAgencyByPlanId(formData?.plan_id, {
    enabled: !!accountData,
  });

  const handleRefresh = () => queryClient.invalidateQueries({ queryKey: ["accounts"] });

  let tabsData = [
    { label: 'Account Owner', content: <AccounTab handleRefresh={handleRefresh} formData={formData} /> },
    { label: 'Business details', content: <ContactTab handleRefresh={handleRefresh} formData={formData} /> },
    ...(formData?.type === 'free' ? [{ label: 'Apps', content: <Apps formData={formData} /> }] : [{ label: 'Apps', content: <PrivateApps formData={privateApps} /> }]),
    { label: 'Users', content: <UserTab users={users.length > 0 && users} /> },
    { label: 'SaaS Mode', content: <SaasTab saasdatda={saasdatda} formData={formData} agencySaas={agencySaas} handleRefresh={handleRefresh} /> },
    { label: 'Rebilling', content: <RebillingTab saasdatda={saasdatda} /> },
    { label: 'Template Agents Name', content: <PromptLabels formData={formData} /> },
    { label: 'Account Plan Allowance', content: <AccountPlan formData={formData} handleRefresh={handleRefresh} /> },
    { label: 'Bespoke integrations Page Only', content: <BespokeUrlPage formData={formData} />, iSection: "This option is bespoke and must consult Maybe* team before using. This is only available for partners not waiting clients to be able to use the Your AI chat feature." },
    { label: 'Bespoke integrations Page', subLabel: '(Consult Maybe* Team before using)', content: <BespokeIntegrations formData={formData} handleRefresh={handleRefresh} /> },
    { label: 'Agent Plugins', content: <AgentConfiguration /> },
  ];

  if (isAccountLoading) {
    return <Loader />;
  }

  return (

    <PageLayout>
      <SoftBox style={{ margin: "10px 20px" }} pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <h1 className="headingpage-branding" >Account</h1>
            <span style={{ fontSize: "14px", cursor: 'pointer' }} onClick={() => navigate(-1)}> {"Accounts"}  {`>`}</span>  <span style={{ fontSize: "14px" }}> {formData.business_name}</span>
            <h1 className=" my-3percent headingpage-branding" >{formData.business_name} <span className="alert-success-new">{formData?.type === "premium" ? formData?.type : "Pay offline"}</span></h1>
            <SoftUITabs tabsData={tabsData} />
          </Grid>
        </Grid>
      </SoftBox>
    </PageLayout>
  );
}

export default AccountDetail;
